import { useEffect, useState } from 'react'

/**
 * returns a single state object to describe whether _any_ of the supplied states
 * are set to true
 *
 * @param states any number of boolean values that may or may not change
 */
export const useAnyTrue = (states: boolean[]) => {
  const [is, set] = useState(false)
  useEffect(() => {
    set(states.some((state) => state === true))
  }, [states])
  return [is, set] as const
}
